import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-publication-published',
  templateUrl: './publication-published.component.html',
  styleUrls: ['./publication-published.component.scss']
})
export class PublicationPublishedComponent implements OnInit {

  @Input() public bought;
  @Input() public message;
  @Input() public title;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }
}
